import { render, staticRenderFns } from "./PromotionAddEdit.vue?vue&type=template&id=0ecb08d1&scoped=true"
import script from "./PromotionAddEdit.vue?vue&type=script&lang=js"
export * from "./PromotionAddEdit.vue?vue&type=script&lang=js"
import style0 from "./PromotionAddEdit.vue?vue&type=style&index=0&id=0ecb08d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecb08d1",
  null
  
)

export default component.exports